module.exports = __webpack_public_path__ + "static/aon-savings-575589b2a14368a378f35b84b0d96c2b.png";